import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import {
  useInvoiceTefPaymentAvailability,
  useInvoiceTefPaymentMethod,
} from '@/core/domain/invoice/invoice/invoice.hooks';
import { InvoiceOriginReferenceEntity } from '@/core/domain/invoice/invoices/invoices.enums';
import { Button, Modal } from 'antd';

export default function PaymentMethodTef() {
  const { invoice, invoiceId } = useInvoiceFormContext();

  const isSales =
    invoice.data?.originReference?.[0].entity ===
    InvoiceOriginReferenceEntity.SALES;

  const isWorkOrder =
    invoice.data?.originReference?.[0].entity ===
    InvoiceOriginReferenceEntity.WORK_ORDER;

  const tefPaymentAvailability = useInvoiceTefPaymentAvailability(
    Number(invoiceId),
  );

  const invoiceTefPaymentMethod = useInvoiceTefPaymentMethod();

  const handleConfirm = () => {
    let title = '';
    let content = '';

    if (isSales) {
      title = 'Importação de pagamentos TEF • Venda direta';
      content =
        'Deseja importar os pagamentos da venda direta vinculados ao TEF?';
    } else if (isWorkOrder) {
      title = 'Importação de pagamentos TEF • Orçamento';
      content = 'Deseja importar os pagamentos do orçamento vinculados ao TEF?';
    }

    Modal.confirm({
      title,
      content,
      okText: 'Vincular',
      onOk: () => invoiceTefPaymentMethod.mutateAsync(Number(invoiceId)),
    });
  };

  if (
    tefPaymentAvailability.isLoading ||
    !tefPaymentAvailability.data?.canShow ||
    !invoiceId
  )
    return null;

  return (
    <>
      <Button
        onClick={handleConfirm}
        loading={invoiceTefPaymentMethod.isLoading}
      >
        Vincular pagamentos TEF
      </Button>
    </>
  );
}
